// Operaciones del catálogo Pro Selection. El texto visible vive en i18n (catalogo.json > pro.verticals).
// `match` identifica el valor del campo operacion_pro_selection que llega del servidor.
export const proVerticals = [
  { id: 'almacenes', match: /almac[eé]n/i },
  { id: 'retail-rutas', match: /^retail$/i },
  { id: 'retail-pos', match: /punto de venta|pos/i },
]
